export const MAX_BEDROOMS = 100;
export const MAX_BATHROOMS = 100;
export const MAX_MINUTES = 100;
export const MAX_PRICE = 1000000000;
export const MAX_SQUARE_FOOTAGE = 1000000;
export const RANGE_TYPE_CRITERIA = ['price', 'bedrooms', 'bathrooms', 'building_size', 'lot_size', 'commute', 'custom_distance', 'grocery', 'parks']
export const SYB_TYPE_CRITERIA = ['crime', 'school_quality', 'solar_power', 'quietness', 'walkability', 'bikeability', 'transit', 'flood_risk']
